﻿import { BooleanEditor, EnumEditor, initFormType, IntegerEditor, PrefixedContext, StringEditor } from "@serenity-is/corelib";
import { DataType } from "./DataType";

export interface SqlProcLookupParameterForm {
    Name: StringEditor;
    Title: StringEditor;
    Type: EnumEditor;
    Required: BooleanEditor;
    Size: IntegerEditor;
    Scale: IntegerEditor;
    Value: StringEditor;
}

export class SqlProcLookupParameterForm extends PrefixedContext {
    static readonly formKey = 'Common.SqlProcLookupParameter';
    private static init: boolean;

    constructor(prefix: string) {
        super(prefix);

        if (!SqlProcLookupParameterForm.init) {
            SqlProcLookupParameterForm.init = true;

            var w0 = StringEditor;
            var w1 = EnumEditor;
            var w2 = BooleanEditor;
            var w3 = IntegerEditor;

            initFormType(SqlProcLookupParameterForm, [
                'Name', w0,
                'Title', w0,
                'Type', w1,
                'Required', w2,
                'Size', w3,
                'Scale', w3,
                'Value', w0
            ]);
        }
    }
}

[DataType]; // referenced types